import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Loader2, Database } from 'lucide-react';
import { toast } from '@/hooks/use-toast';
import { seedTestData } from '@/utils/seedData';

const SeedData = () => {
  const [loading, setLoading] = useState(false);

  const handleSeed = async () => {
    setLoading(true);
    try {
      const result = await seedTestData();
      
      if (result.success) {
        toast({
          title: "Sucesso!",
          description: "Dados de teste criados com sucesso.",
        });
      } else {
        toast({
          title: "Erro",
          description: "Não foi possível criar os dados de teste.",
          variant: "destructive",
        });
      }
    } catch (error) {
      console.error('Erro ao criar dados:', error);
      toast({
        title: "Erro",
        description: "Ocorreu um erro inesperado.",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-accent/10 flex items-center justify-center p-6">
      <Card className="max-w-md w-full">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Database className="w-5 h-5" />
            Criar Dados de Teste
          </CardTitle>
          <CardDescription>
            Popule o banco de dados com dados de exemplo para testar o sistema
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button 
            onClick={handleSeed} 
            className="w-full"
            disabled={loading}
            size="lg"
          >
            {loading ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Criando dados...
              </>
            ) : (
              'Criar Dados de Teste'
            )}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default SeedData;
